module.exports = __webpack_public_path__ + "img/Thumbnails_Community.617e5fff.jpg";